import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

import { FirebaseObjectObservable,
         FirebaseListObservable } from 'angularfire2/database';

import { BackendService } from '../../backend.service';
import { DBService } from '../../db.service';
import { CloudStorageService } from '../../cloud-storage.service';
import { AdminAuthService } from '../../admin-auth.service';
import { slide } from '../../animations';

@Component({
  selector: 'show-member',
  templateUrl: './show-member.component.html',
  styleUrls: ['./show-member.component.scss'],
  animations: [slide]
})
export class ShowMemberComponent implements OnInit {
  @Input() showAdminProfile = false;

  memberObservable: FirebaseObjectObservable<any>;
  galleryObservable: FirebaseListObservable<any>;
  companyObservable: FirebaseObjectObservable<any>;

  member: any;
  userType: string;
  profilePicUrl: string;

  showModalBg = false;
  showFormModal = false;
  showDeleteModal = false;
  showDeletePhotoModal = false;
  showResetPwdModal = false;
  uploadingPhoto = false;
  selectedPhoto = null;

  zoomView = false;
  zoomViewMemberKey = null;
  zoomViewFileKey = null;
  newPassword = Math.random().toString(36).slice(-8).replace(/[l1]/gi,'i');

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private dbService: DBService,
    private csService: CloudStorageService,
    private authService: AdminAuthService,
    private backendService: BackendService
  ) { }

  ngOnInit() {

    if (this.showAdminProfile) {
      let admin = this.authService.getAdmin();
      this.memberObservable = this.dbService.getMember(admin.uid);
      this.memberObservable.subscribe(member => {
        this.member = member;
        this.userType = 'admin';
      });
    } else {
      this.route.params.forEach((params: Params) => {
        this.memberObservable = this.dbService.getMember(params['key']);
        this.galleryObservable = this.dbService.getMemberGallery(params['key']);

        this.memberObservable.subscribe(member => {
          this.member = member;
          if (member.userLevel == 0) {
            this.userType = 'vendor';
          } else {
            this.userType = 'member';
          }

          this.companyObservable = this.dbService.getCompany(member.companyKey);

        });
      });
    }
  }

  onEditClicked() {
    this.showModalBg = true;
    this.showFormModal = true;
  }

  onHideFormModal() {
    this.showFormModal = false;
    this.showModalBg = false;
  }

  onDeleteClicked() {
    this.showModalBg = true;
    this.showDeleteModal = true;
  }

  onHideDeleteModal() {
    this.showDeleteModal = false;
    this.showModalBg = false;
  }

  onResetPwdClicked() {
    this.showResetPwdModal = true;
    this.showModalBg = true;
  }

  onHideResetPwdModal() {
    this.showResetPwdModal = false;
    this.showModalBg = false;
  }

  galleryFull() {
    this.member && this.member.photoGallery && Object.keys(this.member.photoGallery).length >= 12
  }

  onPhotoUpload(event) {
    this.uploadingPhoto = true;
    let file = event.target.files[0];
    /*let reader = new FileReader();

    reader.addEventListener("load", () => {
      this.previewImg.nativeElement.src = reader.result;
    });

    reader.readAsDataURL(file);*/
    this.dbService.addToGallery(this.member, file)
                  .then( d => {
      this.uploadingPhoto = false;
    });

  }

  zoomPhoto(photo) {
    this.showModalBg = true;
    this.zoomView = true;
    this.zoomViewMemberKey = this.member.$key;
    this.zoomViewFileKey = photo.$key;
  }

  closeZoomView() {
    this.showModalBg = false;
    this.zoomView = false;
    this.zoomViewMemberKey = null;
    this.zoomViewFileKey = null;
  }


  onConfirmDelete() {
    this.onHideDeleteModal();
    this.router.navigate([`/companies/${this.member.companyKey}`]);
    this.dbService.deleteMember(this.member.$key);
  }

  deletePhoto(photo) {
    this.showModalBg = true;
    this.showDeletePhotoModal = true;
    this.selectedPhoto = photo;
  }

  onHideDeletePhotoModal() {
    this.selectedPhoto = null;
    this.showModalBg = false;
    this.showDeletePhotoModal = false;
  }

  onConfirmDeletePhoto() {
    this.dbService.removeGalleryPhoto(this.member, this.selectedPhoto.$key);
    this.onHideDeletePhotoModal();
  }

  onConfirmResetPwd() {
    this.backendService.resetPassword(this.member, this.newPassword)
                       .subscribe( data => {
                       });
    this.onHideResetPwdModal();

  }

  notAdmin() {
    this.userType != 'admin';
  }

}



// WEBPACK FOOTER //
// ./src/app/members/show-member/show-member.component.ts